/**
 * Strips the protocol (http/https) and leading "www." from a URL for display purposes.
 * e.g. "https://www.example.com/path" → "example.com/path"
 */
export function formatDisplayUrl(url: string): string {
  return url.replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/+$/, '');
}

/**
 * RFC 3966 `tel:` URI. `internationalPhoneNumber` arrives as "+1 212-219-2777"; spaces are not
 * valid visual separators there, and React Native's `Linking.openURL` can reject the raw form on
 * Android — which surfaces to the traveler as a dead tap.
 *
 * @example formatTelHref('+1 212-219-2777') // 'tel:+12122192777'
 */
export function formatTelHref(phone: string): string {
  const plus = phone.trimStart().startsWith('+') ? '+' : '';
  return `tel:${plus}${phone.replace(/\D/g, '')}`;
}
